import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Datatable } from '../interfaces/datatable';
import { Paginate } from '../interfaces/paginate';

@Injectable({
  providedIn: 'root'
})
export class BaseService<T> {

  constructor(
    protected http: HttpClient,
    @Inject('API_ENDPOINT') protected apiEndpoint: string,
    @Inject('API_PREFIX') protected apiPrefix: string = environment.apiPrefix,
    @Inject('API_URL') protected apiUrl: string = environment.apiUrl
  ) {
    const isCliente = !!localStorage.getItem('cliente_id');

    if (isCliente)
      this.apiPrefix = `app-cliente/${this.apiPrefix}`;
  }

  getAll(queryParams: {} | null = null) {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string]) => {
        params = params.set(chave, valor);
      });
    }

    return this.http.get<T[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}`, { params: params });
  }

  getAllPaginated(pageParams: Paginate, queryParams: {} | null = null) {
    let params = new HttpParams();

    Object.entries(pageParams).forEach(([chave, valor]: [string, string]) => {
      params = params.set(chave, valor);
    });

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string]) => {
        params = params.set(chave, valor);
      });
    }

    return this.http.get<Datatable<T>>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}`, { params: params });
  }

  getById(id: number, queryParams: {} | null = null) {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string]) => {
        params = params.set(chave, valor);
      });
    }

    return this.http.get<T>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}`, { params: params });
  }

  create(body: T | FormData) {
    return this.http.post<T>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}`, body);
  }

  update(id: number, body: T | FormData) {
    return this.http.put<T>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}`, body);
  }

  patch(id: number, body: T | FormData) {
    return this.http.patch<T>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}`, body);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}`);
  }
}
